export const OFFER_TYPE = 6
export const DEFAULT_STOCK_LIMIT = 20
export const HOURS_REMAINING_TO_DISPLAY_STOCK = 22
